
import React from "react";
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

interface LessonCompletionStatusProps {
  isCompleted: boolean;
  onComplete: () => void;
  completionInProgress: boolean;
  nextLesson: any;
  onSelectNextLesson: () => void;
}

const LessonCompletionStatus = ({
  isCompleted,
  onComplete,
  completionInProgress,
  nextLesson,
  onSelectNextLesson
}: LessonCompletionStatusProps) => {
  if (!isCompleted) {
    return (
      <div className="mt-4 mb-6">
        <Button 
          className="w-full bg-green-600 hover:bg-green-700 text-white flex items-center justify-center"
          onClick={onComplete}
          disabled={completionInProgress}
        >
          <CheckCircle className="mr-2 h-5 w-5" />
          {completionInProgress ? "Updating progress..." : "Mark as completed"}
        </Button>
      </div>
    );
  }

  return (
    <>
      <div className="mt-4 mb-6 p-3 bg-green-50 border border-green-200 rounded-md flex items-center">
        <CheckCircle className="h-5 w-5 text-green-600 mr-2" />
        <span className="text-green-800">
          You've completed this lesson
          {nextLesson && " - Continue to the next lesson"}
        </span>
      </div>
      
      {nextLesson && (
        <div className="mt-2 mb-6">
          <Button 
            className="w-full bg-kaija-accent hover:bg-opacity-90 text-white"
            onClick={onSelectNextLesson}
          >
            Continue to: {nextLesson.title}
          </Button>
        </div>
      )}
    </>
  );
};

export default LessonCompletionStatus;
